import React from "react";

export default function RedirectAllURLAttivazione(props) {
  if (props.history.location && props.history.location.pathname) {
    props.history.push("/activate-qrCode");
  }
  return <div />;
}
